export enum TicketStatus {
  APPROVED = 'approved',
  CANCELLED = 'cancelled',
  SETTLED = 'settled',
  WAITING = 'waiting',
  REJECTED = 'rejected', // This is for fallback purposes, matched as wildcards
  LOSE = 'lose',
  WIN = 'win',

  // New sub statuses for cancelled status
  BET_FAILED = 'bet_failed',
  ROUND_CANCELLED = 'round_cancelled',
  USER_CANCELLED = 'user_cancelled',
}

export interface TicketStatusBadgeProps {
  status: TicketStatus
}
